import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=f4ac3b98&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac3b98",
  null
  
)

export default component.exports